import { atom, useRecoilState } from 'recoil';

const sidebarLayoutRecoil = atom<boolean>({
  key: 'sidebarLayoutRecoil',
  default: true,
});

export function useShowSidebarLayout(): any {
  const [showSidebar, setShowSidebar] = useRecoilState(sidebarLayoutRecoil);
  return [showSidebar, setShowSidebar];
}
